// Shared constants for the /solar-grants-wales route (kept out of the route file so
// TanStack's route splitting can resolve them from both head() and the component).
export const PATH = "/solar-grants-wales";
export const TITLE = "Solar Panel Grants Wales 2026: Do You Qualify? | CRS Energy";
export const DESCRIPTION =
  "No universal solar grant in Wales, but 4 routes can fund your panels. Check eligibility: Nest, ECO4 until 31 Dec 2026, 0% VAT to 31 Mar 2027, 0% loans.";

export const FAQS = [
  {
    question: "Are there any grants for solar panels in Wales in 2026?",
    answer:
      "There is no universal solar grant in Wales. Targeted support exists: Warm Homes Nest and ECO4 can fully fund solar for eligible low-income households, Green Homes Wales offers interest-free loans to homeowners, and every installation benefits from 0% VAT until 31 March 2027 plus Smart Export Guarantee payments for exported electricity.",
  },
  {
    question: "Can I get free solar panels in Wales?",
    answer:
      "Only through targeted schemes. Warm Homes Nest (Welsh Government) and ECO4 can fund free solar for eligible households - generally those on means-tested benefits or low incomes in homes with poor energy ratings. Call Nest free on 0808 808 2244 to check your eligibility. Most working households will not qualify.",
  },
  {
    question: "Does CRS Energy still install solar panels under ECO4?",
    answer:
      "No. CRS Energy no longer installs under ECO4 or assists with ECO4 eligibility or applications. We are an approved installer under the Green Homes Plan and carry out recommended installation work for homes that already have a retrofit assessment, including solar PV where specified. Eligibility and funding are determined by the scheme and your assessment. We do not assess eligibility or arrange funding.",
  },
  {
    question: "Is the 0% VAT on solar panels ending?",
    answer:
      "The 0% VAT rate on solar panel and battery storage installations is currently confirmed until 31 March 2027. It is applied automatically by your installer - there is nothing to apply for.",
  },
  {
    question: "How do I get solar if I don't qualify for a grant?",
    answer:
      "You can buy outright or spread the cost. Every installation benefits from 0% VAT and Smart Export Guarantee payments, and our fixed-price package - 6 panels, a hybrid inverter and a 7.2kWh stackable battery for £5,999, subject to suitability - gives you a clear benchmark. You will get a personalised estimate on your first call, with no home visit before you are ready.",
  },
];
